import React, {Component} from "react";
import {Button} from "primereact/button";
import PresvalUploadFileView from "../PresvalUploadFileView";
import {Growl} from "primereact/growl";
import {FileService} from "../../../service/file/FileService";
import {CatalogService} from "../../../service/catalog/CatalogService";
import {Dropdown} from "primereact/dropdown";
import SubtitleLabel from "../../../app/Title/SubtitleLabel/SubtitleLabelView";
import PropTypes from "prop-types";

/**
 * Componente genérico para subir documentos.
 * Sólo se debe incluir en la vista o donde se quiera llamar,
 * con los parámetros que se indican.
 */
export default class UploadFileInstrumentContainer extends Component {
    /**
     * Constructor de la clase, se inicializan las variables.
     * @param {jmap} props Argumento que trae los valores iniciales de la clase
     * Los parámetros que se le pueden poner a este componente son:
     * type: Es el tipo de archivo que recibe, con esto se va a comparar que el
     *      documento sea del mismo tipo.
     *      *Es un dato obligatorio
     * size: Tamaño máximo del archivo.
     *      *Es un dato obligatorio.
     * urlAction: Es la url que se colocará en la petición del back para subir
     *            el archivo.
     *            *Es un dato obligatorio.
     * className: Se usa igual que el del componente botón, para cambiar la apariencia
     *            del botón para buscar el archivo. No es obligatorio.
     * titleHeader: Título que se mostrará en el header del cuadro de diálogo.
     *              No es obligatorio, sino viene se mostrará: "Cargar Archivo Disponible"
     * titleButton: Texto que se mostrará en el botón.
     *              No es obligatorio, sino viene se mostrará: "Cargar Archivo"
     * errorTypeMessage: Mensaje que se mostrará cuando haya un error en el tipo de archivo.
     *              No es obligatorio, sino viene se mostrará: "Error en tipo de documento"
     * errorSizeMessage: Mensaje que se mostrará cuando haya un error en el tamaño del archivo.
     *              No es obligatorio, sino viene se mostrará: "Error en tamaño de documento"
     * instructions: Texto informativo que se muestra en el cuadro de diálogo. No es obligatorio
     * action: Función a la cual se va a reedirigir cuando termine de subir el archivo
     *         Por ejemplo, si se quisiera cargar de nuevo una tabla, se manda esa función.
     *         No es obligatorio."
     *
     */
    /** @param {Record<string, any>} props */
    constructor(props) {
        super(props);
        this.fileService = new FileService();
        this.catalogService = new CatalogService();
        this.getInstruments = this.getInstruments.bind(this);

        this.state = {
            displayDialog: false,
            displayDialogPreview: false,
            fileToSave: null,
            fileName: '',
            instrumentList: this.getInstruments(),
            instrumentObj: {},
        };

        this.onChangeInstrument = this.onChangeInstrument.bind(this);
        this.openUploadFile = this.openUploadFile.bind(this);
        this.onHideDialog = this.onHideDialog.bind(this);
        this.onUpload = this.onUpload.bind(this);
        this.uploadFile = this.uploadFile.bind(this);
        this.onHidePreviewDialog = this.onHidePreviewDialog.bind(this);
    }

    getInstruments() {
        this.catalogService.getCatalogInstrument()
            .then(resp => {
                this.setState({
                    instrumentList: resp,
                });
            });
    }

    /**
     * Función que abre el cuadro de diálogo para subir el archivo.
     */
    openUploadFile() {
        this.setState({
            fileToSave: null,
            displayDialog: true,
            fileName: '',
        });
    }

    /**
     * Función que revisa si el archivo cumple con las especificaciones
     * de tipo y tamaño.
     * @param event Objeto que contiene la información del archivo.
     */
    onUpload(event) {
        let files = event.target.files;

        if (this.props.type.find(function (find){return files[0].type === find}) === undefined) {
            this.growl.show({
                severity: 'error',
                summary: 'Error.',
                detail: (this.props.errorTypeMessage ?
                    this.props.errorTypeMessage : "Error en tipo de documento")
            });
        } else if (files[0].size >= this.props.size) {
            this.growl.show({
                severity: 'error',
                summary: 'Error.',
                detail: (this.props.errorSizeMessage ?
                    this.props.errorSizeMessage : "Error en tamaño de documento")
            });
        } else {
            this.setState({
                fileToSave: event.target.files[0],
                fileName: event.target.files[0].name,
            });
        }
    }

    /**
     * Función que sube el archivo por medio de una servicio en el back
     * Realiza las validaciones de que haya un archivo, que haya url para la petición,
     * y si hay params que sean del tipo requerido.
     * También llama a la función especificada en "action" en caso de que haya.
     */
    uploadFile() {
        if (!this.state.instrumentObj.emisoraSerieCupon) {
            this.growl.show({
                severity: 'error',
                summary: 'Error.',
                detail: 'Seleccione un instrumento para garantizar.'
            });
        } else if (this.state.fileToSave === null) {
            this.growl.show({
                severity: 'error',
                summary: 'Error.',
                detail: 'Seleccione un archivo.'
            });
        } else if ((this.props.urlAction === null) || (this.props.urlAction === "")) {
            this.growl.show({
                severity: 'error', summary: 'Error.',
                detail: "No se pudo guardar el documento"
            });
        } else {
            this.props.loadingFunc(true);
            let emisoraSerieTipo = this.state.instrumentObj.emisoraSerie + " " + this.state.instrumentObj.tipoValor;
            let paramsAux = {
                collateral: emisoraSerieTipo,
            };
            this.fileService.uploadFile(this.state.fileToSave, this.props.urlAction, paramsAux)
                .then(res => {
                    if (res.errors === undefined || res.errors.length === 0) {
                        this.growl.show({
                            severity: 'success', summary: 'Éxito.',
                            detail: 'Se ha cargado el archivo con éxito'
                        });
                    } else if (res.errors.length > 0){
                        this.growl.show({
                            severity: 'error', summary: 'Error.',
                            detail: res.errors.join(", ")
                        });
                    }
                    this.props.loadingFunc(false);
                    return this.props.action ? this.props.action() : "";
                });

            this.setState({
                fileToSave: null,
                displayDialog: false,
                fileName: '',
                instrumentObj: {}
            });
        }
    }

    /**
     * Función que cierra el cuadro de diálogo
     */
    onHideDialog() {
        this.setState({displayDialog: false});
    }

    onHidePreviewDialog() {
        this.setState({displayDialogPreview: false, displayDialog: false});
    }

    /**
     * Función que maneja el cambio en el dropdown
     * Coloca el valor en una variable del estado.
     * @param event Contiene el valor y el objeto modificado.
     */
    onChangeInstrument(event) {
        const {name, value} = event.target;
        this.setState({[name]: value,})
    }

    /**
     * Función que realiza el render de la pantalla cuando existe un cambio.
     * En esta se le pasa a la vista lo que necesita para pintarse.
     * @returns {*}
     */
    render() {
        let buttonOpen =
            <Button type="button" iconPos="left"
                    label={this.props.titleButton ?
                        this.props.titleButton : "Cargar Archivo"}
                    className={this.props.className ? this.props.className : ""}
                    onClick={this.openUploadFile}
            />;

        let dialogHeader =
            <div className="p-grid p-fluid">
                <div className="p-col-12 p-md-6 p-lg-8" style={{padding: '.1em'}}>
                    <h2 className={"secondary-text"}> {this.props.titleHeader ?
                        this.props.titleHeader : "Cargar Archivo Disponible"}</h2>
                </div>
                <div className="p-col-12 p-md-3 p-lg-2" style={{padding: '.3em'}}>
                    <Button label="Regresar" onClick={this.onHideDialog}
                            className="p-button-secondary"/>
                </div>
                <div className="p-col-12 p-md-3 p-lg-2" style={{padding: '.3em'}}>
                    <Button label="Guardar" onClick={this.uploadFile}/>
                </div>
            </div>;

        let dialogPreviewHeader =
            <div className="p-grid p-fluid">
                <div className="p-col-12 p-md-6 p-lg-8" style={{padding: '.1em'}}>
                    <h2>Vista Previa</h2>
                </div>
                <div className="p-col-12 p-md-6 p-lg-4" style={{padding: '.3em'}}>
                    <Button label="Aceptar" onClick={this.onHidePreviewDialog}/>
                </div>
            </div>;

        let bodyUploadFile =
            <div className="p-col-12 p-md-6 p-lg-6" style={{overflow:"visible"}}>
                <SubtitleLabel header="Garantía" isBold={true}/>
                <Dropdown name="instrumentObj"
                          options={this.state.instrumentList}
                          filterBy="emisoraSerieCupon"
                          optionLabel="emisoraSerieCupon"
                          placeholder="Seleccione..."
                          onChange={this.onChangeInstrument}
                          value={this.state.instrumentObj}
                />
            </div>;

        let uploadMessagesGrowl = <Growl ref={(el) => this.growl = el} style={{textAlign: 'left',}}/>;

        const {displayDialog, fileName, displayDialogPreview} = this.state;

        return <PresvalUploadFileView buttonOpen={buttonOpen}
                                      displayDialog={displayDialog}
                                      displayDialogPreview={displayDialogPreview}
                                      onHideDialog={this.onHideDialog}
                                      onUpload={this.onUpload}
                                      dialogHeader={dialogHeader}
                                      dialogPreviewHeader={dialogPreviewHeader}
                                      fileName={fileName}
                                      uploadMessagesGrowl={uploadMessagesGrowl}
                                      bodyUploadFile={bodyUploadFile}
                                      instructions={(this.props.instructions ? this.props.instructions : "")}/>
    }
};

UploadFileInstrumentContainer.propTypes = {
    type: PropTypes.array.isRequired,
    errorTypeMessage: PropTypes.string.isRequired,
    size: PropTypes.string.isRequired,
    errorSizeMessage: PropTypes.string.isRequired,
    urlAction: PropTypes.string.isRequired,
    action: PropTypes.func,
    titleButton: PropTypes.string,
    className: PropTypes.string,
    titleHeader: PropTypes.string,
    instructions: PropTypes.string,
    loadingFunc: PropTypes.func,
}